import React, { FC } from 'react';
import { FootballPosition, POSITION_CONFIGS } from '../types/footballPosition';
import './PitchPositionSelector.css';
import scorzaPitch from '../assets/images/scorza-pitch.svg';
import { useTranslation } from "react-i18next";

interface PitchPositionSelectorProps {
    selectedPosition?: FootballPosition | null;
    onPositionChange: (position: FootballPosition | null) => void;
}

export const PitchPositionSelector: FC<PitchPositionSelectorProps> = ({
    selectedPosition,
    onPositionChange,
}) => {
    const handlePositionClick = (position: FootballPosition) => {
        // If the same position is clicked, keep it selected (no deselection)
        // If a different position is clicked, select the new one
        onPositionChange(position);
    };
    const {t}= useTranslation();
    return (
        <div className="pitch-container">
            <div className="pitch-field">
                {/* Football pitch SVG background */}
                <img 
                    src={scorzaPitch}
                    alt="Football pitch"
                    className="pitch-svg-background"
                />
                
                {/* Position markers overlay */}
                <div className="pitch-background">
                    {/* Render all position markers */}
                    {POSITION_CONFIGS.map((config) => (
                        <div
                            key={config.code}
                            className={`position-marker ${
                                selectedPosition === config.code ? 'selected' : ''
                            }`}
                            style={{
                                top: config.top,
                                left: config.left,
                            }}
                            onClick={() => handlePositionClick(config.code)}
                            data-testid={`position-${config.code}`}
                            data-depth={config.depth}
                        >
                            <div className="position-circle">
                                <span className="position-label">{t(`positions.codes.${config.code}`)}</span>
                            </div>
                            <div className="position-name">{t(`positions.names.${config.code}`)}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PitchPositionSelector;